import React, { useState, useRef, useEffect } from "react";
import TextFieldGroup from "../../commons/TextFieldGroup";
import Searchbar from "../../commons/Searchbar";
import qs from "qs";

import {
  Layout,
  Breadcrumb,
  Form,
  Table,
  Divider,
  message,
  Input,
  Col,
  Row,
  Collapse,
  PageHeader,
  Button,
} from "antd";

import {
  formItemLayout,
  smallFormItemLayout,
  tailFormItemLayout,
} from "./../../utils/Layouts";
import isEmpty from "../../validation/is-empty";
import { useSelector } from "react-redux";
import {
  edit,
  onDelete,
  onSubmit,
  onSearch,
  onDeleteItem,
  onChange,
  onUpdateStatus,
  hasAccess,
} from "../../utils/form_utilities";
import moment from "moment";
import SelectFieldGroup from "../../commons/SelectFieldGroup";
import {
  addKeysToArray,
  onCustomerSearch,
  onProjectSearch,
} from "../../utils/utilities";
import DatePickerFieldGroup from "../../commons/DatePickerFieldGroup";
import TextAreaGroup from "../../commons/TextAreaGroup";
import round from "../../utils/round";

import WarehouseFormModal from "../modals/WarehouseFormModal";
import { useNavigate, useParams } from "react-router-dom";
import FormButtons from "../../commons/FormButtons";
import classNames from "classnames";
import {
  ACCESS_ADD,
  ACCESS_ADVANCE_SEARCH,
  ACCESS_OPEN,
  CANCELLED,
  OPEN,
  ORIENTATION_HORIZONTAL,
  ORIENTATION_VERTICAL,
  STATUS_CLOSED,
} from "../../utils/constants";
import RangeDatePickerFieldGroup from "../../commons/RangeDatePickerFieldGroup";
import SimpleSelectFieldGroup from "../../commons/SimpleSelectFieldGroup";
import AccountFormModal from "../modals/AccountFormModal";
import CheckboxGroupFieldGroup from "../../commons/CheckboxGroupFieldGroup";
import { media_type_options } from "../../utils/Options";
import RadioGroupFieldGroup from "../../commons/RadioGroupFieldGroup";
import numberFormat from "../../utils/numberFormat";
import computeItemDetails from "../../utils/computeItemDetails";
import { sumBy } from "lodash";
import CheckboxFieldGroup from "../../commons/CheckboxFieldGroup";
import axios from "axios";
const { Content } = Layout;
const { Panel } = Collapse;
const url = "/api/billing-statement/";
const title = "Billing Statement Slip";

const initialItemValues = {
  description: "",
  quantity: "",
  unit: "",
  price: "",
  amount: "",
  reference: "",
};

const transaction_counter = {
  label: "BS #",
  key: "bs_no",
};

const date_fields = ["date", "due_date"];

export default function BillingStatementForm({}) {
  const params = useParams();
  const [errors, setErrors] = useState({});
  const [records, setRecords] = useState([]);
  const [processing, setProcessing] = useState(false);
  const [total_records, setTotalRecords] = useState(null);
  const [current_page, setCurrentPage] = useState(1);
  const [search_keyword, setSearchKeyword] = useState("");
  const auth = useSelector((state) => state.auth);
  const [item, setItem] = useState(initialItemValues);
  const [dr_numbers, setDrNumbers] = useState([]);
  const [options, setOptions] = useState({
    suppliers: [],
    stocks: [],
    purchase_orders: [],
    warehouses: [],
    projects: [],
  });
  const [page_size, setPageSize] = useState(100);

  const [loading, setLoading] = useState(false);
  const accountFormModal = useRef(null);
  const warehouseFormModal = useRef(null);

  const items_column = [
    {
      title: "Qty",
      dataIndex: "quantity",
      align: "right",
      width: 50,
      render: (value, record, index) => (
        <span>
          {record.footer !== 1 &&
          [undefined, null, OPEN].includes(state.status?.approval_status) ? (
            <Row gutter={8}>
              <Col span={24}>
                <input
                  type="number"
                  step={0.01}
                  className="has-text-right input-value"
                  value={record.quantity}
                  onChange={(e) => {
                    const value = e.target.value;

                    setState((prevState) => {
                      let items = [...state.items];
                      let item = items[index];
                      const quantity = value;

                      items[index] = {
                        ...items[index],
                        ...computeItemDetails({
                          ...items[index],
                          quantity,
                        }),
                      };

                      //add row
                      if (state.items.length - 1 === index) {
                        items.push({ ...initialItemValues });
                      }

                      return {
                        ...prevState,
                        items,
                      };
                    });
                  }}
                  align="right"
                />
              </Col>
            </Row>
          ) : (
            `${numberFormat(record.quantity)}`
          )}
        </span>
      ),
    },
    {
      title: "Unit",
      dataIndex: "unit",
      width: 100,
      render: (value, record, index) => (
        <span>
          {record.footer !== 1 &&
          [undefined, null, OPEN].includes(state.status?.approval_status) ? (
            <Row gutter={8}>
              <Col span={24}>
                <input
                  className=" input-value"
                  value={record.unit}
                  onChange={(e) => {
                    const value = e.target.value;

                    setState((prevState) => {
                      let items = [...state.items];
                      let item = items[index];
                      const unit = value;

                      items[index] = {
                        ...items[index],
                        unit,
                      };

                      //add row
                      if (state.items.length - 1 === index) {
                        items.push({ ...initialItemValues });
                      }

                      return {
                        ...prevState,
                        items,
                      };
                    });
                  }}
                />
              </Col>
            </Row>
          ) : (
            record.unit
          )}
        </span>
      ),
    },
    {
      title: "Articles",
      dataIndex: "description",

      render: (value, record, index) => (
        <span>
          {record.footer !== 1 &&
          [undefined, null, OPEN].includes(state.status?.approval_status) ? (
            <Row gutter={8}>
              <Col span={24}>
                <input
                  className="input-value full-width"
                  value={record.description}
                  onChange={(e) => {
                    const value = e.target.value;

                    setState((prevState) => {
                      let items = [...state.items];

                      const description = value;

                      items[index] = {
                        ...items[index],
                        description,
                      };

                      //add row
                      if (state.items.length - 1 === index) {
                        items.push({ ...initialItemValues });
                      }

                      return {
                        ...prevState,
                        items,
                      };
                    });
                  }}
                />
              </Col>
            </Row>
          ) : (
            record.description
          )}
        </span>
      ),
    },
    {
      title: "Price",
      dataIndex: "price",
      align: "right",
      width: 100,
      render: (value, record, index) => (
        <span>
          {record.footer !== 1 &&
          [undefined, null, OPEN].includes(state.status?.approval_status) ? (
            <Row gutter={8}>
              <Col span={24}>
                <input
                  type="number"
                  step={0.01}
                  className="has-text-right input-value"
                  value={record.price}
                  onChange={(e) => {
                    const value = e.target.value;
                    setState((prevState) => {
                      let items = [...state.items];
                      let item = items[index];
                      const price = value;

                      items[index] = {
                        ...items[index],
                        ...computeItemDetails({
                          ...items[index],
                          price,
                        }),
                      };

                      //add row
                      if (state.items.length - 1 === index) {
                        items.push({ ...initialItemValues });
                      }
                      return {
                        ...prevState,
                        items,
                      };
                    });
                  }}
                  align="right"
                />
              </Col>
            </Row>
          ) : (
            record.footer !== 1 && `${numberFormat(record.price)}`
          )}
        </span>
      ),
    },
    {
      title: "Amount",
      dataIndex: "amount",
      align: "right",
      width: 200,
      render: (value, record, index) => (
        <span>{`${numberFormat(record.amount)}`}</span>
      ),
    },
    ,
    {
      title: "",
      key: "action",
      width: 80,
      align: "center",
      render: (text, record, index) => (
        <span>
          {record.footer !== 1 &&
            [undefined, OPEN].includes(state.status?.approval_status) && (
              <span
                onClick={() =>
                  onDeleteItem({
                    field: "items",
                    index,
                    setState,
                  })
                }
              >
                <i className="fas fa-trash-alt"></i>
              </span>
            )}
        </span>
      ),
    },
  ];

  const navigate = useNavigate();
  const [search_state, setSearchState] = useState({});

  const initialValues = {
    _id: null,
    date: moment(),
    items: [
      {
        ...initialItemValues,
      },
    ],

    is_taxable: true,
    is_vat_exclusive: true,
  };
  const [state, setState] = useState(initialValues);

  const records_column = [
    {
      title: "BS #",
      dataIndex: "billing_statement_no",
    },
    {
      title: "Date",
      dataIndex: "date",
      render: (date) => moment(date).format("MM/DD/YYYY"),
    },

    {
      title: "Account",
      dataIndex: ["project", "account", "name"],
    },

    {
      title: "Project",
      dataIndex: ["project", "name"],
    },
    {
      title: "Terms",
      dataIndex: ["account", "terms_desc"],
    },
    {
      title: "Due Date",
      dataIndex: "due_date",
      render: (date) => moment(date).format("MM/DD/YYYY"),
    },

    {
      title: "Total Amount",
      dataIndex: ["total_amount"],
      render: (value) => numberFormat(value),
    },
    {
      title: "Total Payment Amount",
      dataIndex: ["total_payment_amount"],
      render: (value) => numberFormat(value),
    },

    {
      title: "Status",
      dataIndex: ["status"],
      align: "center",
      render: (status, record, index) => {
        return (
          <span
            className={classNames("has-text-weight-bold", {
              "has-text-danger": status?.approval_status === CANCELLED,
            })}
          >
            {status?.approval_status || ""}
          </span>
        );
      },
    },
  ];

  useEffect(() => {
    let vat_amount = 0,
      total_gross_amount = 0;
    const project_price = parseFloat(
      sumBy(state.items, (o) => parseFloat(o.amount || 0))
    );

    if (state.is_taxable) {
      if (state.is_vat_exclusive) {
        vat_amount = round(project_price * 0.12);
        total_gross_amount = round(project_price + vat_amount);
      } else {
        vat_amount = round((project_price / 1.12) * 0.12);
        total_gross_amount = project_price;
      }
    } else {
      total_gross_amount = project_price;
      vat_amount = 0;
    }

    setState((prevState) => ({
      ...prevState,
      vat_amount,
      total_amount: total_gross_amount,
    }));

    return () => {};
  }, [
    state.is_taxable,
    state.is_vat_exclusive,
    state.project_price,
    state.items,
  ]);

  useEffect(() => {
    if (state.date && state.account?.terms >= 0) {
      const due_date = moment(state.date)
        .add({
          days: parseInt(state.account?.terms, 10),
        })
        .endOf("day");

      setState((prevState) => ({
        ...prevState,
        due_date,
      }));
    }

    return () => {};
  }, [state.date, state.account?.terms]);

  useEffect(() => {
    const query = qs.parse(location.search, { ignoreQueryPrefix: true });

    (async () => {
      if (isEmpty(params?.id) && !isEmpty(search_state.branch?._id)) {
        setTimeout(() => {
          onSearch({
            page: current_page,
            page_size,
            search_keyword,
            url,
            setRecords,
            setTotalRecords,
            setCurrentPage,
            setErrors,
            advance_search: { ...search_state },
          });
        }, 300);
      }
    })();

    return () => {};
  }, [search_state.branch]);

  useEffect(() => {
    if (params?.id) {
      edit({
        record: {
          _id: params.id,
        },
        setState: (record) => {
          const items = record.items;

          items.push({
            ...initialItemValues,
          });

          setState({
            ...record,
            items,
          });
        },
        setErrors,
        setRecords,
        url,
        date_fields,
      });
    }
    return () => {};
  }, []);

  useEffect(() => {
    if (!state._id) {
      axios
        .post(url + "latest-reference")
        .then((response) =>
          setState((prevState) => ({
            ...prevState,
            reference: response.data + 1,
          }))
        )
        .catch((err) => console.log(err));
    }
    return () => {};
  }, [state._id]);

  useEffect(() => {
    const amount = round(
      round(round(item.case_quantity) * round(item.case_price)) +
        round(round(item.quantity) * round(item.price))
    );

    setItem((prevState) => {
      return {
        ...prevState,
        amount,
      };
    });

    return () => {};
  }, [item.case_quantity, item.quantity, item.case_price, item.price]);

  const can_edit =
    isEmpty(state.status) || [OPEN].includes(state.status?.approval_status);

  return (
    <Content className="content-padding">
      <WarehouseFormModal
        setField={(warehouse) => {
          setState((prevState) => ({
            ...prevState,
            warehouse,
          }));
        }}
        ref={warehouseFormModal}
      />
      <AccountFormModal
        setField={(account) => {
          setState((prevState) => ({
            ...prevState,
            account,
          }));
        }}
        ref={accountFormModal}
      />
      <div className="columns is-marginless">
        <div className="column">
          <Breadcrumb style={{ margin: "16px 0" }}>
            <Breadcrumb.Item>Home</Breadcrumb.Item>
            <Breadcrumb.Item className="text-color-yellow">
              {title}
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <div className="column">
          <Searchbar
            name="search_keyword"
            onChange={(e) => setSearchKeyword(e.target.value)}
            value={search_keyword}
            onNew={
              hasAccess({
                auth,
                access: ACCESS_ADD,
                location,
              })
                ? () => {
                    setState({
                      ...initialValues,
                      date: moment(),
                      branch: auth.user?.branches?.[0] || null,
                    });
                    setItem(initialItemValues);
                    setRecords([]);
                  }
                : null
            }
          />
        </div>
      </div>

      {hasAccess({
        auth,
        access: ACCESS_ADVANCE_SEARCH,
        location,
      }) && (
        <Row>
          <Col span={24} className="m-b-1">
            <Collapse>
              <Panel header="Advance Search" key="1">
                <PageHeader
                  backIcon={false}
                  style={{
                    border: "1px solid rgb(235, 237, 240)",
                  }}
                  onBack={() => null}
                  title="Advance Filter"
                  subTitle="Enter appropriate data to filter records"
                >
                  <div className="or-slip-form">
                    <Row>
                      <Col span={8}>
                        <RangeDatePickerFieldGroup
                          label="Date"
                          name="period_covered"
                          value={search_state.period_covered}
                          onChange={(dates) =>
                            setSearchState((prevState) => ({
                              ...prevState,
                              period_covered: dates,
                            }))
                          }
                          formItemLayout={smallFormItemLayout}
                        />
                      </Col>
                      <Col span={8}>
                        <SelectFieldGroup
                          label="Project"
                          value={search_state.project?.name}
                          onFocus={() => {
                            onProjectSearch({ value: "", setOptions });
                          }}
                          onSearch={(value) =>
                            onProjectSearch({ value, setOptions })
                          }
                          onChange={(index) => {
                            const project = options.projects?.[index] || null;
                            setSearchState((prevState) => ({
                              ...prevState,
                              project,
                            }));
                          }}
                          formItemLayout={smallFormItemLayout}
                          data={options.projects}
                          column="name"
                        />
                      </Col>
                      <Col span={8}>
                        <SelectFieldGroup
                          label="Account"
                          value={search_state.account?.name}
                          onFocus={() => {
                            onCustomerSearch({ value: "", setOptions });
                          }}
                          onSearch={(value) =>
                            onCustomerSearch({ value, setOptions })
                          }
                          onChange={(index) => {
                            const account = options.accounts?.[index] || null;
                            setSearchState((prevState) => ({
                              ...prevState,
                              account,
                            }));
                          }}
                          formItemLayout={smallFormItemLayout}
                          data={options.accounts}
                          column="name"
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col span={8}>
                        <SimpleSelectFieldGroup
                          label="Status"
                          name="approval_status"
                          value={search_state.approval_status}
                          onChange={(value) => {
                            onChange({
                              key: "approval_status",
                              value: value,
                              setState: setSearchState,
                            });
                          }}
                          error={errors?.approval_status}
                          formItemLayout={smallFormItemLayout}
                          options={[OPEN, STATUS_CLOSED, CANCELLED] || []}
                        />
                      </Col>
                      <Col span={8}>
                        <TextFieldGroup
                          label="BS #"
                          name="bs_no"
                          formItemLayout={smallFormItemLayout}
                          value={search_state[transaction_counter.key]}
                          onChange={(e) => {
                            onChange({
                              key: e.target.name,
                              value: e.target.value,
                              setState: setSearchState,
                            });
                          }}
                        />
                      </Col>
                      <Col span={8}></Col>
                    </Row>
                    <Row>
                      <Col span={8}>
                        <TextFieldGroup
                          label="Reference"
                          name="reference"
                          formItemLayout={smallFormItemLayout}
                          value={search_state.reference}
                          onChange={(e) => {
                            onChange({
                              key: e.target.name,
                              value: e.target.value,
                              setState: setSearchState,
                            });
                          }}
                        />
                      </Col>
                    </Row>

                    <Row>
                      <Col span={8}>
                        <Row>
                          <Col offset={8} span={12}>
                            <Button
                              type="info"
                              size="large"
                              icon={
                                <i className="fa-solid fa-magnifying-glass pad-right-8"></i>
                              }
                              onClick={() => {
                                onSearch({
                                  page: 1,
                                  page_size,
                                  search_keyword,
                                  url,
                                  setRecords,
                                  setTotalRecords,
                                  setCurrentPage,
                                  setErrors,
                                  advance_search: { ...search_state },
                                });
                              }}
                            >
                              Search
                            </Button>
                          </Col>
                        </Row>
                      </Col>
                      <Col span={8}></Col>
                      <Col span={8}></Col>
                    </Row>
                  </div>
                </PageHeader>
              </Panel>
            </Collapse>
          </Col>
        </Row>
      )}

      <div
        style={{
          background: "#fff",
          padding: 24,
          borderBottomLeftRadius: 10,
          borderBottomRightRadius: 10,
        }}
      >
        <Row>
          <Col span={12}>
            <span className="module-title">{title}</span>
          </Col>
          {/* <Col span={12} className="has-text-right">
            <Button
              type="link"
              onClick={() => {
                navigate("/cashier");
              }}
            >
              Go Back Cashiering
            </Button>
          </Col> */}
        </Row>

        <Divider />
        {isEmpty(records) ? (
          <Form
            onFinish={() => {
              onSubmit({
                values: {
                  ...state,
                  project: {
                    ...state.project,
                    latest_billing_date: moment(),
                  },
                  items: state.items.filter((o) => !isEmpty(o.description)),
                },
                auth,
                url,
                setErrors,
                setState,
                date_fields,
                setLoading,
              });
            }}
            initialValues={initialValues}
          >
            {state[transaction_counter.key] && (
              <Row>
                <Col span={12}>
                  <TextFieldGroup
                    label={transaction_counter.label}
                    value={state[transaction_counter.key]}
                    error={errors.remarks}
                    formItemLayout={smallFormItemLayout}
                    readOnly
                  />
                </Col>
              </Row>
            )}

            <Row>
              <Col span={12}>
                <DatePickerFieldGroup
                  label="Date"
                  name="date"
                  value={state.date || null}
                  onChange={(value) => {
                    onChange({
                      key: "date",
                      value: value,
                      setState,
                    });
                  }}
                  error={errors.date}
                  formItemLayout={smallFormItemLayout}
                />
              </Col>
              <Col span={12}>
                <TextFieldGroup
                  label="Reference"
                  name="reference"
                  value={state.reference}
                  error={errors.reference}
                  onChange={(e) => {
                    onChange({
                      key: e.target.name,
                      value: e.target.value,
                      setState,
                    });
                  }}
                  formItemLayout={smallFormItemLayout}
                />
              </Col>
            </Row>

            <Row>
              <Col span={12}>
                <SelectFieldGroup
                  label="Account"
                  value={state.account?.name}
                  onFocus={() => {
                    onCustomerSearch({ value: "", setOptions });
                  }}
                  onSearch={(value) => onCustomerSearch({ value, setOptions })}
                  onChange={(index) => {
                    const account = options.accounts?.[index] || null;
                    setState((prevState) => ({
                      ...prevState,
                      account,
                      project: null,
                    }));
                  }}
                  formItemLayout={smallFormItemLayout}
                  data={options.accounts}
                  column="name"
                  error={errors.account}
                />
              </Col>
              <Col span={12}>
                <SelectFieldGroup
                  label="Project"
                  value={state.project?.name}
                  onFocus={() => {
                    onProjectSearch({
                      value: "",
                      setOptions,
                      account_id: state.account?._id,
                    });
                  }}
                  onSearch={(value) =>
                    onProjectSearch({
                      value,
                      setOptions,
                      account_id: state.account?._id,
                    })
                  }
                  onChange={(index) => {
                    const project = options.projects?.[index] || null;
                    setState((prevState) => ({
                      ...prevState,
                      project,
                    }));
                  }}
                  formItemLayout={smallFormItemLayout}
                  data={options.projects}
                  column="name"
                  error={errors.project}
                  // onAddItem={() => accountFormModal.current.open()}
                />
              </Col>
            </Row>

            <TextFieldGroup
              disabled
              label="Terms"
              name="terms"
              value={state.account?.terms_desc}
              formItemLayout={formItemLayout}
            />

            <DatePickerFieldGroup
              disabled
              label="Due Date"
              name="due_date"
              value={state.due_date || null}
              onChange={(value) => {
                onChange({
                  key: "due_date",
                  value: value,
                  setState,
                });
              }}
              error={errors.due_date}
              formItemLayout={formItemLayout}
            />

            <Row>
              <Col span={12}>
                <CheckboxFieldGroup
                  label="Taxable"
                  name="is_taxable"
                  error={errors.is_taxable}
                  checked={state.is_taxable}
                  formItemLayout={smallFormItemLayout}
                  onChange={(e) => {
                    onChange({
                      key: e.target.name,
                      value: e.target.checked,
                      setState,
                    });
                  }}
                />
              </Col>
              <Col span={12}>
                <CheckboxFieldGroup
                  label="Vat Ex"
                  name="is_vat_exclusive"
                  error={errors.is_vat_exclusive}
                  checked={state.is_vat_exclusive}
                  formItemLayout={smallFormItemLayout}
                  onChange={(e) => {
                    onChange({
                      key: e.target.name,
                      value: e.target.checked,
                      setState,
                    });
                  }}
                />
              </Col>
            </Row>

            <Row>
              <Col span={12}>
                <TextFieldGroup
                  disabled
                  label="Vat Amount"
                  name="vat_amount"
                  value={state.vat_amount}
                  formItemLayout={smallFormItemLayout}
                />
              </Col>
              <Col span={12}>
                <TextFieldGroup
                  disabled
                  label="Total Amount"
                  name="total_amount"
                  value={state.total_amount}
                  formItemLayout={smallFormItemLayout}
                />
              </Col>
            </Row>

            {state.status && state.status.datetime && (
              <TextFieldGroup
                label="Status"
                name="status"
                value={`${state.status.approval_status} / ${
                  state.status.user.name
                } / ${moment(state.status.datetime).format("LLL")}`}
                formItemLayout={formItemLayout}
                readOnly
              />
            )}
            {state.deleted && state.deleted.date && (
              <TextFieldGroup
                label="Voided By"
                name="status"
                value={`${state.deleted?.user?.name} / ${moment(
                  state.deleted.date
                ).format("LLL")}`}
                formItemLayout={formItemLayout}
                readOnly
              />
            )}

            <Table
              dataSource={addKeysToArray([
                ...state.items,
                {
                  footer: 1,
                  quantity: sumBy(state.items, (o) => round(o.quantity || 0)),

                  amount: sumBy(state.items, (o) => round(o.amount || 0)),
                },
              ])}
              columns={items_column}
              pagination={false}
              rowClassName={(record, index) => {
                if (record.footer === 1) {
                  return "footer-summary has-text-weight-bold";
                }
              }}
            />

            <FormButtons
              state={state}
              auth={auth}
              loading={loading}
              url={url}
              initialValues={initialValues}
              initialItemValues={initialItemValues}
              setState={setState}
              setItem={setItem}
              onDelete={() => {
                onDelete({
                  id: state._id,
                  url,
                  user: auth.user,
                  additional_data: state.project?.latest_billing_date,
                  cb: () => {
                    onSearch({
                      page: current_page,
                      page_size,
                      search_keyword,
                      url,
                      setRecords,
                      setTotalRecords,
                      setCurrentPage,
                      setErrors,
                      advance_search: { ...search_state },
                    });
                  },
                });
              }}
              onSearch={() => {
                onSearch({
                  page: current_page,
                  page_size,
                  search_keyword,
                  url,
                  setRecords,
                  setTotalRecords,
                  setCurrentPage,
                  setErrors,
                  advance_search: { ...search_state },
                });
              }}
              onClose={() => {
                //before closing, save first
                onSubmit({
                  values: {
                    ...state,
                    items: state.items.filter((o) => !isEmpty(o.description)),
                  },
                  auth,
                  url,
                  setErrors,
                  setState,
                  date_fields,
                  setLoading,
                  cb: () => {
                    onUpdateStatus({
                      url,
                      state: {
                        ...state,
                        items: state.items.filter(
                          (o) => !isEmpty(o.description)
                        ),
                      },
                      approval_status: STATUS_CLOSED,
                      user: auth.user,
                      cb: () => {
                        edit({
                          record: state,
                          setState,
                          setErrors,
                          setRecords,
                          url,
                          date_fields,
                        });
                      },
                    });
                  },
                });
              }}
              has_print={!isEmpty(state._id)}
              has_cancel={!isEmpty(state._id)}
              onPrint={() => console.log("Print")}
              has_save={can_edit}
            />
          </Form>
        ) : (
          <Table
            dataSource={addKeysToArray(records)}
            columns={records_column}
            rowKey={(record) => record._id}
            onRow={(record, index) => {
              return {
                onDoubleClick: (e) => {
                  if (
                    hasAccess({
                      auth,
                      access: ACCESS_OPEN,
                      location,
                    })
                  ) {
                    edit({
                      record,
                      setState: (record) => {
                        const items = record.items;

                        items.push({
                          ...initialItemValues,
                        });

                        setState({
                          ...record,
                          items,
                        });
                      },
                      setErrors,
                      setRecords,
                      url,
                      date_fields,
                    });
                  }
                },
              };
            }}
            pagination={{
              current: current_page,
              defaultCurrent: current_page,
              onChange: (page, page_size) => {
                setPageSize(page_size);
                onSearch({
                  page,
                  page_size,
                  search_keyword,
                  url,
                  setRecords,
                  setTotalRecords,
                  setCurrentPage,
                  setErrors,
                  advance_search: { ...search_state },
                });
              },
              total: total_records,
              pageSize: page_size,
            }}
          />
        )}
      </div>
    </Content>
  );
}
